import type { PlatformItem } from '../lib/types';

interface Props {
  platforms: PlatformItem[];
  selected: string;
  onSelect: (id: string) => void;
  /** Set berisi slug platform yang sedang maintenance. */
  maintenance?: Set<string>;
}

/**
 * Horizontal scrollable chips untuk memilih platform. Scroll aktif
 * hanya bila chip melebihi lebar layar; di mobile 375px, ~4 chip
 * terlihat sekaligus.
 *
 * Platform maintenance diberi titik oranye + opacity turun. Tetap bisa
 * diklik (user boleh coba), tapi visual menandai kemungkinan gangguan.
 */
export function PlatformChips({
  platforms,
  selected,
  onSelect,
  maintenance,
}: Props) {
  return (
    <div className="-mx-4 overflow-x-auto px-4 [&::-webkit-scrollbar]:hidden">
      <div className="flex gap-2 pb-1" style={{ scrollbarWidth: 'none' }}>
        {platforms.map((p) => {
          const active = p.id === selected;
          const isMaint = maintenance?.has(p.id) ?? false;
          return (
            <button
              key={p.id}
              type="button"
              onClick={() => onSelect(p.id)}
              title={isMaint ? 'Platform sedang bermasalah / maintenance' : undefined}
              className={`relative flex min-h-[44px] shrink-0 items-center rounded-full px-4 text-sm font-semibold transition ${
                active
                  ? 'bg-gold-grad text-gold-ink shadow-gold'
                  : 'bg-ink-800 text-neutral-400 hover:text-neutral-200'
              } ${isMaint && !active ? 'opacity-50' : ''}`}
            >
              {p.displayName}
              {isMaint && (
                <span
                  className="absolute right-1 top-1.5 h-2 w-2 rounded-full bg-amber-500 ring-2 ring-ink-950"
                  aria-label="maintenance"
                />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
